<script>
import AppDisplay from '@/components/AppDisplay.vue'
import { formataStringYearMonthToBr } from '@/utils/utils'
import { opcoesTipoSistemaTI, opcoesEspecies, opcoesTipoAlimentacao } from '@/libs/constants/praticas/opcoesSelects'
import Irrigacao from '../components/Irrigacao.vue'
import Financiamento from '../components/Financiamento.vue'
import Descricao from '../components/Descricao.vue'

export default {
  components: {
    AppDisplay,
    Irrigacao,
    Financiamento,
    Descricao
  },
  props: {
    pratica: {
      type: Object
    }
  },
  methods: {
    formataStringYearMonthToBr,
    formataTipoSistema (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.filter(value => value !== 'OUTROS')?.map(value => opcoesTipoSistemaTI.find(opcao => opcao.id === value)?.nome)
      return opcoesFormatadas.join(', ')
    },
    formataEspecieRaca (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => `• Raça: ${value.raca} / Espécie: ${opcoesEspecies.find(especie => especie.id === value.especie).nome}`)
      return opcoesFormatadas.join('<br /> ')
    },
    formataTiposAlimentacoes (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => opcoesTipoAlimentacao.find(opcao => opcao.id === value)?.nome)
      return opcoesFormatadas.join(', ')
    }
  }
}
</script>

<template>
  <div>
    <div>
      <span class="title-praticas">Dados da prática</span>
      <hr />
    </div>
    <el-row>
      <el-col :span="12">
        <app-display label="Área da unidade de produção animal (ha):" :content="pratica.area" />
        <app-display label="Número de animais por área (unidade/ha):" :content="pratica.numeroAnimais" />
        <app-display label="Espécie e raça:" :content="formataEspecieRaca(pratica.especiesRacas)" :isContentInNextLine="true" />
        <app-display label="Data de início da implementação (mês/ano):" :content="formataStringYearMonthToBr(pratica.dataInicio)" />
      </el-col>
      <el-col :span="12">
        <app-display label="Tipo de sistema:" :content="formataTipoSistema(pratica.tiposSistemas)" />
        <app-display label="Outro tipo de sistema:" :content="pratica.outrosTipoSistema" />
        <app-display label="Tipo de alimentação:" :content="formataTiposAlimentacoes(pratica.tiposAlimentacao)" />
        <app-display label="Outro tipo de alimentação:" :content="pratica.outroTipoAlimentacao" />
        <app-display label="Suplementação mineral?" :content="pratica.hasSuplementacaoMineral ? 'Sim' : 'Não'" />
      </el-col>
    </el-row>
    <Irrigacao :irrigacao="{possuiIrrigacao: pratica.possuiIrrigacao, ...pratica.irrigacao}" />
    <Financiamento :financiamento="{financiamentos: pratica.financiamentos, outroFinanciamento: pratica.outroFinanciamento}" />
    <Descricao :descricao="pratica.descricao" />
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/TI/TI.vue